var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "sidebar-transaction"
  }, [_c('b-sidebar', {
    attrs: {
      "no-header": "",
      "right": "",
      "shadow": "",
      "bg-variant": "white"
    },
    model: {
      value: _vm.isOpen,
      callback: function ($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_c('div', {
    staticClass: "sidebar-transaction__header p-1 d-flex justify-content-between align-items-center"
  }, [_c('h4', {
    staticClass: "mb-0 text-primary text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.$t('ar_client_details_transaction')) + " ")]), _c('ez-icon', {
    staticClass: "cursor-pointer",
    attrs: {
      "icon": "ezAr-icon-x",
      "size": "24",
      "color": "#114A9F"
    },
    on: {
      "click": function ($event) {
        _vm.isOpen = false;
      }
    }
  })], 1), _c('div', {
    staticClass: "sidebar-transaction__content p-1"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t("ar_common_general_info")))]), _c('b-row', {
    staticClass: "sidebar-transaction__content--info"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-text-snippet"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_client_payments')) + ": 12321312312 ")], 1), _c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-home"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_clinent_transaction_type')) + ": 12321312312 ")], 1), _c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-clock"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_clinent_Transaction_time')) + ": 12321312312 ")], 1), _c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-grid"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_clinent_allotted_to')) + ": 12321312312 ")], 1)])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-calendar"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_client_total_money')) + ": 12321312312 ")], 1), _c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-calendar"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_clinent_transaction_type')) + ": 12321312312 ")], 1), _c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-user"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_clinent_Transaction_time')) + ": 12321312312 ")], 1), _c('li', {
    staticClass: "infor-item"
  }, [_c('ez-icon', {
    staticClass: "ic-bg-24",
    attrs: {
      "icon": "ezAr-icon-grid"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ar_clinent_allotted_to')) + ": 12321312312 ")], 1)])])], 1)], 1), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "p-1"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_allocation_history")))]), _c('b-table', {
    staticClass: "mt-1",
    attrs: {
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "items": _vm.itemListHistory,
      "fields": _vm.headersListHistory
    }
  }), _c('div', {
    staticClass: "mt-1 d-flex justify-content-between align-items-center"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('ar_client_showing_info_record', {
    record: _vm.perPage,
    total: _vm.perPage
  })) + " ")]), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.itemListHistory.length,
      "per-page": _vm.perPage,
      "aria-controls": "my-table"
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)]), _vm.isOpen ? _c('div', {
    staticClass: "sidebar-transaction__backrop w-100 h-100 fixed-top",
    on: {
      "click": function ($event) {
        _vm.isOpen = false;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }